export default __webpack_public_path__ + "static/media/79g.931060c8.svg";